import { UserAnswer } from '../robot.types';

export function getCodeFromUserAnswer(userAnswer?: UserAnswer): string {
    if (typeof userAnswer === 'object') {
        return userAnswer.answer.code;
    }
    return userAnswer || '';
}
